/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { StyleSheet, css } from 'aphrodite';

import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { AppHelper } from '../../helpers/AppHelper';
import { BaseEntityPage } from './BaseEntityPage';
import { Controller } from '../Controller';
import { UiHelper } from '../helpers/UiHelper';
import { AppConfig } from '../../AppConfig';
import { CommonTheme } from '../../styles/Styles';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { SearchBar } from './SearchBar';
import { FormControl, Grid, TextField } from '@material-ui/core';
import { StatCard } from './StatCard';
import Autocomplete from '@material-ui/lab/Autocomplete';

function processOrgUsersData({orgUsers, subOrgs}) {
  if(!Array.isArray(orgUsers) && orgUsers.length === 0) return null
  orgUsers.forEach(i => i.id = i.userId)
  orgUsers.sort((a, b) => (a.email || a.givenname || '').localeCompare(b.email || b.givenname || ''))
  orgUsers = Object.values(
    orgUsers.reduce((acc, user) => {
      const { userId, orgId, roles } = user

      if(userId) {
        if (!acc[userId]) {
          acc[userId] = {
            ...user,
            accessLevels: {}
          }
        }

        if (orgId) {
          acc[userId].accessLevels[orgId] = {
            roles: [...(roles || [])]
          }
        }
      }

      return acc
    }, {})
  )
  orgUsers = orgUsers.map(user => {
    const { roles, ...cleanedUser } = user
    return cleanedUser
  })
  orgUsers.forEach((user)=>{
    if(user && user.accessLevels) {
      const accessLevels = Object.entries(user.accessLevels)
      accessLevels.forEach(([key, value])=>{
        if(key && value) {
          let orgTitle = ''
          const {orgId, subOrgId} = AppHelper.parseOrgUnitId(key)
          if(Array.isArray(subOrgs) && subOrgs.length > 0 && subOrgId) {
            const subOrg = subOrgs.find((obj) => {
              return obj && obj.id === subOrgId
            })
            if(subOrg) {
              orgTitle = subOrg.title
            }
          } else {
            orgTitle = UiHelper.getOrgTitle()
          }
          value.orgTitle = orgTitle
        }
      })
    }
  })

  return orgUsers
}

function parseCurrent(current) {
  if (!current || typeof current !== 'object') {
    return null
  }
  const currentUser = JSON.parse(JSON.stringify(current))
  const accessLevels = currentUser.accessLevels
  const teams = []
  let roles = []

  if (accessLevels && typeof accessLevels === 'object') {
    const keys = Object.keys(accessLevels)

    for (let i = 0; i < keys.length; i++) {
      const team = keys[i]
      const parsed = AppHelper.parseOrgUnitId(team)
      if(parsed) {
        if (parsed.subOrgId) {
          teams.push(team)
        } else {
          const value = accessLevels[team]
          if (value && Array.isArray(value.roles)) {
            roles = value.roles.slice()
          }
        }
      }
    }
  }

  const parsedCurrent = currentUser
  parsedCurrent.teams = teams
  parsedCurrent.roles = roles
  delete parsedCurrent.accessLevels
  return parsedCurrent
}

function searchOnUserList(userList, searchText) {
  let filteredUserList = []
  if(Array.isArray(userList) && userList.length > 0 && searchText) {
    const search = searchText.toLowerCase()
    filteredUserList = userList.filter((user) => {
      let fullName = ''
      if(user.givenname || user.familyname) {
        fullName = Helper.formatName(user)
      }
      return (
        fullName && fullName.toLowerCase().includes(search) ||
        user.email && user.email.toLowerCase().includes(search)
      )
    })
  }

  return filteredUserList
}

export class StaffOfOrg extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.subOrgId = this.props.match.params.subOrgId // optional if we are on a suborgs staff page
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.teamsEnabled = AppHelper.isTeamsEnabled(this.orgId)
    this.pageTitle = this.orgId === 'PRODUCT' ?
      Helper.getString('productusers') : Helper.getString('admins')
    this.pageKey = 'usersOfOrg'
    this.isMobileView = Helper.isMobileView()
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() }
    ]
    if(this.subOrgId) {
      this.breadCrumbs.push({ title: Helper.getString('suborgs'), to: this.baseRoute() + '/suborgs' })
    }
    this.breadCrumbs.push({ title: this.pageTitle })
    this.toFetch = [
      { key: 'usersORG', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-org-users2'], queryParams: { orgId: this.orgId, parentOrgId: this.orgId} },
    ]
    if(this.orgId !== 'PRODUCT') {
      this.toFetch.push({ key: 'orgs', method: 'GET', endPoint: ApiHelper.makeUrlPath(['orgs', this.subOrgId || this.orgId]) })
    }
    if (this.teamsEnabled) {
      this.toFetch.push({ key: 'suborgs', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-sub-orgs'], queryParams: {orgId: this.orgId, parentOrgId: this.orgId } })
    }

    this.cellWidths = {
      Index: Styles.cellWidthSmall,
      Name: Styles.cellWidthNormal,
      'Email/Phone': Styles.cellWidthMedium,
      Status: Styles.cellWidthSmall,
      'Access Levels': Styles.cellWidthWide,
    }

    this.tableHeadersMap = {
      Index: (current) => { return current.__index + 1 },
      Name: (current) => { return Helper.formatName(current) },
      'Email/Phone': (current) => { return current.email || current.phone },
      Status: (current) => {
        if(current) {
          return (<div className={css(Styles.statusContainer)}>
            {current.state && <span className={current.state === 'LIVE' ? css(Styles.line2, Styles.statusBadge, Styles.statusBadgeLive) : css(Styles.line2, Styles.statusBadge)}>{current.state}</span>}
            {current.email && Helper.isSlixtaStaff(current.email) && <span className={css(Styles.line2, Styles.statusBadge, Styles.customerSuccessBadge)}>{Helper.getString('customerSuccess')}</span>}
          </div>)
        }
      },
      'Access Levels': (current) => {
        if(current && current.accessLevels) {
          const accessLevels = Object.entries(current.accessLevels)
          if(accessLevels.length > 0) {
            return (
              <div className={css(Styles.container)}>
                {accessLevels.map((accessLevel) => {
                  const orgUnitId = accessLevel[0]
                  const value = accessLevel[1]
                  if(value && Array.isArray(value.roles) && value.roles.length > 0) {
                    return (
                      <div key={orgUnitId} className={css(Styles.teamRow)}>
                        <span className={css(Styles.teamTitle)}>
                          {value.orgTitle || orgUnitId}:
                        </span>
                        {value.roles.join(', ')}
                      </div>
                    )
                  }
                })}
              </div>)
          }
        }
        return null
      },
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.emptyText = 'No staff in this org yet!'
    this.apiData = {}
    this.headerActions = [
      {
        label: 'Add',
        tooltip: 'Add Staff',
        icon: 'person_add',
        type: 'icon-label',
        onClick: () => this.openModalForAdd(),
      },
    ]

    if(AppHelper.isStaffActivityTrackingEnabled(this.orgId)) {
      this.headerActions.push( {
        label: 'Interactions',
        tooltip: 'Staff Interactions',
        icon: 'timeline',
        type: 'icon-label',
        onClick: () => this.openStaffActivityReport(),
      })
    }
    this.state.searchText = ''
    this.teams = [
      {key: 'all', label: 'All'},
      {key: this.orgId, label: `${UiHelper.getOrgTitle()} [Parent Org]`}
    ]
    this.team = this.teams[0]
    this.mainOrgRoles = [
      {key: 'any', label: 'Any'},
    ]
    this.mainOrgRole = this.mainOrgRoles[0]
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onFetchSuccess(results) {
    this.usersOrgResult = this.getResult(results, 'usersORG')
    if(this.usersOrgResult && this.usersOrgResult.fieldDef &&  this.usersOrgResult.items) {
      this.fieldDef =  this.usersOrgResult.fieldDef
      this.usersOrg =  this.usersOrgResult.items
      this.orgsResult = this.getResult(results, 'orgs')
      if (this.teamsEnabled) {
        this.subOrgs = this.getResult(results, 'suborgs') ? this.getResult(results, 'suborgs').items : []
      }
      if(this.orgId === 'PRODUCT') {
        this.fieldDef.steps[0].fields.find(i => i.key === 'roles').options = [
          {key: 'SUPERUSER', label: 'SUPERUSER'},
        ]
      } else if(this.subOrgId) {
        if(this.orgsResult) {
          this.pageTitle = this.orgsResult.title
        }
        this.fieldDef.steps[0].fields.find(i => i.key === 'roles').options = [
          {key: 'CRM', label: 'CRM'},
        ]
      } else {
        if(this.orgsResult) {
          this.pageTitle = this.orgsResult.title
        }
        this.fieldDef.steps[0].fields.find(i => i.key === 'roles').options = [
          {key: 'SUPERUSER', label: 'SUPERUSER'},
          {key: 'BLOGGER', label: 'BLOGGER'},
          {key: 'CRM', label: 'CRM'},
          {key: 'VIEWER', label: 'VIEWER'},
        ]
      }

      if(this.fieldDef) {
        this.fieldDef = Helper.removeFieldsFromFieldDef(this.fieldDef, ['phone','pictureName','designation'])
        const emailField = Helper.getField(this.fieldDef, 'email')
        if(emailField) {
          emailField.placement = 'left'
        }

        if(Array.isArray(this.fieldDef.steps) && this.fieldDef.steps[0] && Array.isArray(this.fieldDef.steps[0].fields)) {
          const fields = this.fieldDef.steps[0].fields
          fields.push({
            key: 'state',
            type: 'radio',
            label: 'Status',
            tip: 'Status',
            options: [{key: 'LIVE', label: 'LIVE'}, {key: 'DISABLED', label: 'DISABLED'}],
            v_required: {
              value: true,
              err: 'Choose a status'
            },
            placement: 'right',
            defaultValue: 'LIVE',
          })
          const rolesField = Helper.getField(this.fieldDef, 'roles')
          if(rolesField) {
            rolesField.label = 'Main Org Roles'
            rolesField.placement = 'left'
            rolesField.v_required = {
              value: false,
              err: 'Provide Main Org Roles'
            }
          }

          if(this.teamsEnabled) {
            fields.push({
              key: 'teams',
              type: 'check_box',
              label: 'Teams',
              tip: 'Teams',
              options: [],
              v_required: {
                value: false,
                err: 'Provide Teams'
              },
              placement: 'right'
            })
          }
          if(this.subOrgs) {
            UiHelper.populateOptions(this.fieldDef, {items: this.subOrgs}, 'teams')
          }
          fields.push({
            key: 'ctcPhone',
            type: 'edit_text',
            label: 'Click-to-call phone',
            tip: 'Optional. If set, it must be a valid phone number (include country code).',
            v_required: {
              value: false,
              err: 'Provide click-to-call phone',
            },
            phone: {
              value: true,
              err: Helper.getString('invalidNumber'),
            },
            placement: 'left',
          })
        }
      }

      this.formDefinition = this.fieldDef
      const items = processOrgUsersData({orgUsers: this.usersOrg, subOrgs: this.subOrgs})

      let teams = [...this.teams]
      const teamsField = Helper.getField(this.fieldDef, 'teams')
      if(teamsField && teamsField.options && teamsField.options.length > 0) {
        teams = [...teams, ...teamsField.options]
      }

      let mainOrgRoles = [...this.mainOrgRoles]
      const rolesField = Helper.getField(this.fieldDef, 'roles')
      if(rolesField && rolesField.options && rolesField.options.length > 0) {
        mainOrgRoles = [...mainOrgRoles, ...rolesField.options]
      }

      const prevTeamKey = (this.state.teamSelected && this.state.teamSelected.key) || this.team.key
      const prevRoleKey = (this.state.mainOrgRoleSelected && this.state.mainOrgRoleSelected.key) || this.mainOrgRole.key

      this.setState({
        masterUserList: items,
        stats: this.usersOrgResult.stats,
        teamSelected: teams.find(option => option.key === prevTeamKey) || teams[0],
        teams: teams,
        mainOrgRoleSelected: mainOrgRoles.find(option => option.key === prevRoleKey) || mainOrgRoles[0],
        mainOrgRoles: mainOrgRoles
      },()=>{
        this.onSearch(this.state.searchText)
      })
    } else {
      const prevTeamKey = (this.state.teamSelected && this.state.teamSelected.key) || this.team.key
      const prevRoleKey = (this.state.mainOrgRoleSelected && this.state.mainOrgRoleSelected.key) || this.mainOrgRole.key

      this.setState({
        masterUserList: [],
        items:[],
        teamSelected: this.teams.find(option => option.key === prevTeamKey) || this.teams[0],
        teams: this.teams,
        mainOrgRoleSelected: this.mainOrgRoles.find(option => option.key === prevRoleKey) || this.mainOrgRoles[0],
        mainOrgRoles: this.mainOrgRoles
      })
    }
  }

  openStaffActivityReport() {
    window.open(`/admin/orgs/${this.orgId}/staff-interactions` , '_self')
  }

  openModalForAdd() {
    this.apiData = {
      isAdd: true,
    }
    const fieldDef = JSON.parse(JSON.stringify(this.fieldDef))
    fieldDef.title = Helper.getString('addStaff')
    this.setState({
      loadingMode: ApiHelper.LOADING_MODE.TABLE_LOAD,
    },()=>{
      super.openModalForAdd(fieldDef)
    })
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'add-staff-user'],
        queryParams: { orgId: this.orgId, parentOrgId: this.orgId }
      })
    });
  }

  openModalForDelete(current) {
    this.apiData = {
      isDelete: true,
    }
    const fieldDef = JSON.parse(JSON.stringify(this.fieldDef))
    fieldDef.title = Helper.getString('deleteStaff')
    const parsedCurrent = parseCurrent(current)
    this.setState({
      loadingMode: ApiHelper.LOADING_MODE.TABLE_LOAD,
    },()=>{
      super.openModalForDelete(parsedCurrent, fieldDef)
    })
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'delete-staff-user'],
        queryParams: { orgId: this.orgId, parentOrgId: this.orgId }
      })
    });
  }

  openModalForEdit(current) {
    this.apiData = {
      isEdit: true,
    }
    const fieldDef = JSON.parse(JSON.stringify(this.fieldDef))
    fieldDef.title = Helper.getString('editStaff')
    const parsedCurrent = parseCurrent(current)

    this.setState({
      loadingMode: ApiHelper.LOADING_MODE.TABLE_LOAD,
    },()=>{
      super.openModalForEdit(parsedCurrent, fieldDef)
    })
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'update-staff-user'],
        queryParams: { orgId: this.orgId, parentOrgId: this.orgId }
      })
    });
  }

  onActions(current) {
    const actions = []
    actions.push(UiHelper.buttonEdit(this, current))
    if (Controller.get().userMgr().isProductSU() || AppHelper.isSettingEnabled(this.orgId, 'STAFF_DELETE_BUTTON')) {
      actions.push(UiHelper.buttonDelete(this, current))
    }
    if (AppHelper.isStaffActivityTrackingEnabled(this.orgId)) {
      actions.push(<Link to={`/admin/orgs/${this.orgId}/staff-activity/${current.userId}`} key={current.userId}>
        <Tooltip title='View Staff' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>arrow_forward_ios</i>
          </span>
        </Tooltip>
      </Link>)
    }
    return actions
  }

  onTeamsAutoCompleteChange = (value) => {
    if(value && value.key && this.state.masterUserList) {
      let filteredItems = this.state.masterUserList

      if(value.key !== 'all') {
        filteredItems = filteredItems.filter((item)=>{
          if(item && item.accessLevels && item.accessLevels[value.key]) {
            return item
          }
        })
      }

      if(this.state.searchText) {
        filteredItems = searchOnUserList(filteredItems, this.state.searchText)
      }

      this.setState({
        teamSelected: value,
        mainOrgRoleSelected: this.mainOrgRole,
        items: filteredItems
      })
    }
  }

   onMainOrgRolesAutoCompleteChange = (value) => {
     if(value && value.key && this.state.masterUserList) {
       let filteredItems = this.state.masterUserList

       if(this.state.teamSelected && this.state.teamSelected.key) {
         if(this.state.teamSelected.key !== 'all') {
           filteredItems = filteredItems.filter((item)=>{
             if(item && item.accessLevels && item.accessLevels[this.state.teamSelected.key]) {
               return item
             }
           })
         }

         if(value.key !== 'any') {
           filteredItems = filteredItems.filter((item)=>{
             if(item && item.accessLevels && item.accessLevels[this.state.teamSelected.key] &&  item.accessLevels[this.state.teamSelected.key].roles && item.accessLevels[this.state.teamSelected.key].roles.includes(value.key)) {
               return item
             }
           })
         }
       }
       if(this.state.searchText) {
         filteredItems = searchOnUserList(filteredItems, this.state.searchText)
       }
       this.setState({
         mainOrgRoleSelected: value,
         items: filteredItems
       })
     }
   }

   renderFilters() {
     return (<div className={css(Styles.filterContainer)}>
       <div className={css(Styles.formControlContainer)}>
         <p className={css(Styles.label)}>{'Team'}</p>
         <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
           <Autocomplete
             value={this.state.teamSelected || this.team}
             options={this.state.teams || this.teams}
             onChange={(e, val) => this.onTeamsAutoCompleteChange(val)}
             getOptionLabel={(option) => option.label || option.text}
             getOptionSelected={(option, value) => option.key === value.key}
             disableClearable
             forcePopupIcon={this.state.teams.length > 1}
             popupIcon={this.state.teams.length > 1 ? undefined : null}
             open={this.state.teams.length > 1 ? undefined : false}
             renderInput={params =>
               <TextField
                 {...params}
                 variant={'standard'}
                 className={css(Styles.formControlFilters)}
                 InputProps={{
                   ...params.InputProps,
                   disableUnderline: true,
                   readOnly: true,
                   classes: {
                     root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                     input: css(Styles.formInputStyle, Styles.textInput),
                   },
                 }} />}
           />
         </FormControl>
       </div>
       {this.state.teamSelected && this.state.teamSelected.key && this.state.teamSelected.key === this.orgId && <div className={css(Styles.formControlContainer)}>
         <p className={css(Styles.label)}>{'Role'}</p>
         <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
           <Autocomplete
             value={this.state.mainOrgRoleSelected || this.mainOrgRole}
             options={this.state.mainOrgRoles || this.mainOrgRoles}
             onChange={(e, val) => this.onMainOrgRolesAutoCompleteChange(val)}
             getOptionLabel={(option) => option.label || option.text}
             getOptionSelected={(option, value) => option.key === value.key}
             disableClearable
             forcePopupIcon={this.state.mainOrgRoles.length > 1}
             popupIcon={this.state.mainOrgRoles.length > 1 ? undefined : null}
             open={this.state.mainOrgRoles.length > 1 ? undefined : false}
             renderInput={params =>
               <TextField
                 {...params}
                 variant={'standard'}
                 className={css(Styles.formControlFilters)}
                 InputProps={{
                   ...params.InputProps,
                   disableUnderline: true,
                   readOnly: true,
                   classes: {
                     root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                     input: css(Styles.formInputStyle, Styles.textInput),
                   },
                 }} />}
           />
         </FormControl>
       </div>}
     </div>)
   }

   renderAboveTable() {
     const cardsData = [
       {
         key: 'userLicenses',
         text: (this.state.stats && this.state.stats.userLicenses) || 0,
         subText: 'Licenses',
         cardIndex: 1,
         cardId: 'userLicenses',
         padding: 'small'
       },
       {
         key: 'liveUsersNonSlixta',
         text: (this.state.stats && this.state.stats.liveUsersNonSlixta) || 0,
         subText: 'Active Users',
         cardIndex: 2,
         cardId: 'liveUsersNonSlixta',
         padding: 'small'
       },
       {
         key: 'superUsersNonSlixta',
         text: (this.state.stats && this.state.stats.superUsersNonSlixta) || 0,
         subText: 'Super Users',
         cardIndex: 3,
         cardId: 'superUsersNonSlixta',
         padding: 'small'
       }
     ]

     return (<div className={css(Styles.statsContainer)}>
       {this.renderFilters()}
       {cardsData && cardsData.length > 0 && <Grid container className={css(Styles.numericStatContainerRow)}>
         {cardsData.map((card)=>(
           <StatCard
             xs={4}
             sm={1}
             key={card.key}
             text={card.text}
             subText={card.subText}
             cardIndex={card.cardIndex}
             padding={card.padding}
             cardId={card.cardId}
             handleCardClick={card.handleCardClick}
             containerStyle={Styles.statsCardContainer}
             cardStyle={Styles.statsCard}
           />))}
       </Grid>}
       <div className={css(Styles.searchBarContainer)} onSubmit={(e) => e.preventDefault()}>
         <SearchBar
           hint={Helper.getString('staffSearchHint')}
           onSearch={this.onSearch.bind(this)}
           onClearSearch={this.clearSearch.bind(this)}
           searchText={this.state.searchText}
           searchButtonLabel='Filter'
           clearSearchLabel='Clear'
           autoRefresh={true}
           debounceDuration={1}
           autoFocus={true}
           hideFiltersContainer={true}
         >
         </SearchBar>
       </div>
     </div>)
   }

   onSearch(searchText = '') {
     let filteredItems = this.state.masterUserList

     if(this.state.teamSelected && this.state.teamSelected.key !== 'all') {
       filteredItems = filteredItems.filter((item)=>{
         if(item && item.accessLevels && item.accessLevels[this.state.teamSelected.key]) {
           return item
         }
       })
     }

     if(this.state.mainOrgRoleSelected && this.state.mainOrgRoleSelected.key !== 'any') {
       filteredItems = filteredItems.filter((item)=>{
         if(item && item.accessLevels && item.accessLevels[this.state.teamSelected.key] &&  item.accessLevels[this.state.teamSelected.key].roles && item.accessLevels[this.state.teamSelected.key].roles.includes(this.state.mainOrgRoleSelected.key)) {
           return item
         }
       })
     }

     if(searchText) {
       filteredItems = searchOnUserList(filteredItems, searchText)
     }

     this.setState({
       searchText: searchText,
       items:filteredItems
     })
   }

   clearSearch() {
     this.setState({
       searchText: '',
       teamSelected: this.team,
       mainOrgRoleSelected: this.mainOrgRole,
       items:this.state.masterUserList
     })
   }

   async customSubmit(options) {
     const { formType, formData, caller } = options
     if (formData && (formData.isAdd || formData.isEdit || formData.isDelete)) {

       if((!Array.isArray(formData.teams) || formData.teams.length === 0) && (!Array.isArray(formData.roles) || formData.roles.length === 0)) {
         caller.setState({
           fetchState: ApiHelper.State.ERROR,
           errMsg: this.teamsEnabled ? Helper.getString('mainOrgRolesOrTeamsRequiredErrMsg2') : Helper.getString('mainOrgRolesOrTeamsRequiredErrMsg1'),
           success: false,
           message: this.teamsEnabled ? Helper.getString('mainOrgRolesOrTeamsRequiredErrMsg2') : Helper.getString('mainOrgRolesOrTeamsRequiredErrMsg1'),
           inProcess: false
         })
         return
       }

       let accessLevels = {}

       if (Array.isArray(formData.teams) && formData.teams.length > 0) {
         accessLevels = formData.teams.reduce((acc, orgUnitId) => {
           acc[orgUnitId] = {
             roles: ['CRM']
           }
           return acc
         }, {})
         if(Array.isArray(formData.roles) && formData.roles.length > 0) {
           accessLevels[this.orgId] = {
             roles: formData.roles || []
           }
         }
       } else if(Array.isArray(formData.roles) && formData.roles.length > 0) {
         accessLevels = {
           [this.orgId]: {
             roles: formData.roles || []
           }
         }
       }

       formData.accessLevels = accessLevels

       delete formData.isAdd
       delete formData.isEdit
       delete formData.isDelete
       delete formData.teams
       delete formData.roles
     }

     return caller.submit.call(caller, formData, true);
   }

}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    backgroundColor: 'white',
    color: CommonTheme.textColor,
    fontSize: 16,
    padding: '16px 5px',
    wordBreak: 'break-word',
  },
  teamTitle: {
    fontWeight: 500,
    marginRight: 5
  },
  cellWidthSmall: {
    width: '10%',
    padding: '8px 5px',
  },
  cellWidthNormal: {
    width: '20%',
    padding: '8px 5px',
  },
  cellWidthMedium: {
    width: '30%',
    padding: '8px 5px',
  },
  cellWidthWide: {
    width: '50%',
    padding: '8px 5px',
  },
  line2: {
    fontSize: 10,
    color: 'grey'
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 5
  },
  statusBadge: {
    backgroundColor: AppTheme.primaryBg,
    padding: 5,
    borderRadius: 10,
    wordBreak: 'keep-all',
    display: 'block',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
  },
  statusBadgeLive: {
    backgroundColor: '#3BDE86',
    color: '#222222'
  },
  customerSuccessBadge: {
    backgroundColor: '#A9E3FF',
    color: '#222222'
  },
  statsContainer: {
    width: '100%'
  },
  searchBarContainer: {
    width: '100%'
  },
  filterContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
    marginBottom: '16px',
  },
  numericStatItemRow: {
    '@media (max-width: 1024px)': {
      alignSelf: 'center',
      paddingTop: '8px',
      paddingBottom: '8px',
      height: '100%',
    },
    width: '100%',
  },
  numericStatContainerRow: {
    height: '100%',
    maxHeight: '100%',
    maxWidth: AppTheme.viewPort,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2px 0px 0px 0px',
    margin: 0,
    gap: 5,
    marginBottom: '16px',
    '@media (max-width: 1024px)': {
      padding: '2px 0px',
      gap: 0
    },
  },
  statsCardContainer: {
    maxWidth: 'unset',
    flex: 1,
  },
  statsCard: {
    width: '100%'
  },
  formControlContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 5,
  },
  label: {
    fontSize: 14,
    color: CommonTheme.subTextColor,
    margin: 0,
    display: 'inline-block'
  },
  formControlMainFilters: {
    width: 240,
    '@media (min-width: 768px) and (max-width: 1024px)': {
      width: '60%',
      alignSelf: 'center',
    },
    '@media (max-width: 767px)': {
      width: '60%',
      alignSelf: 'center',
    },
  },
  formControlFilters: {
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden'
  },
  textInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16
  },
  autoCompleteInputRoot: {
    paddingRight: 48,
    '@media (max-width: 440px)': {
      paddingRight: 18,
    },
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  textInput: {
    padding: '4px 0px',
    '@media (max-width: 440px)': {
      fontSize: 12,
    },
  },
})